import React from 'react';
import { Box, Heading, Text, Container, useColorModeValue } from '@chakra-ui/react';

interface DashboardHeaderProps {
  firstName?: string;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({ firstName }) => {
  const gradientBg = useColorModeValue(
    'linear(to-r, #3182ce, #7346c3)',
    'linear(to-r, #3182ce, #7346c3)'
  );

  return (
    <Box mb={8} bgGradient={gradientBg} p={8} borderRadius="xl">
      <Container maxW="full">
        <Heading size="2xl" mb={2} color="white" textAlign={'end'}>
          Welcome back, {firstName}! 👋
        </Heading>
        <Text color="white" fontSize="lg" textAlign={'end'}>
          Here's what's happening with your projects today
        </Text>
      </Container>
    </Box>
  );
};

export default DashboardHeader;
